import { CaretDown, CaretRight } from '@liveauctioneers/hammer-ui-core/icons';
import { H3, H4 } from '@liveauctioneers/hammer-ui-core/text';
import { ReactNode } from 'react';
import { Collapse } from 'react-collapse';

import useWindowSize from '@/hooks/useWindowSize';
import { QueryParams, SetActiveIdCallback } from '@/pages/Notifications/notifications.types';
import { mergedCaterwaulAndHammerUIThemes } from '@/theme/mergedCaterwaulAndHammerUIThemes';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { TableRow } from './TableRow';

type Props = {
    activeId: QueryParams['section'];
    browser?: ReactNode;
    component: ReactNode;
    count: number;
    email?: ReactNode;
    id: QueryParams['section'];
    setActiveId: SetActiveIdCallback;
    sms?: ReactNode;
};

export const Section = ({ activeId, browser, component, count, email, id, setActiveId, sms }: Props) => {
    const formatMessage = useAppFormatMessage();
    const { width } = useWindowSize();
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = mergedCaterwaulAndHammerUIThemes;

    const open = activeId === id;

    return (
        <>
            <section
                className="h-[84px] cursor-pointer items-center"
                onClick={() => {
                    setActiveId(open ? '' : id);
                }}
            >
                <TableRow
                    browser={browser}
                    email={email}
                    sms={sms}
                    type={
                        <div className="flex h-[52px] items-center">
                            <span className="mr-2xs block h-sm w-sm">
                                {open ? (
                                    <CaretDown
                                        size="xs"
                                        style="fill"
                                    />
                                ) : (
                                    <CaretRight
                                        size="xs"
                                        style="fill"
                                    />
                                )}
                            </span>
                            {width > tabletNarrowWidthNum ? (
                                <H3 data-testid="sectionOption">
                                    {formatMessage(['notificationsPage', 'section', id], {
                                        values: {
                                            count,
                                        },
                                    })}
                                </H3>
                            ) : (
                                <H4 data-testid="sectionOption">
                                    {formatMessage(['notificationsPage', 'section', id], {
                                        values: {
                                            count,
                                        },
                                    })}
                                </H4>
                            )}
                        </div>
                    }
                />
            </section>
            <Collapse isOpened={open}>
                <div>{component}</div>
            </Collapse>
        </>
    );
};
